/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_SubtitleInputs */

const en_landing_hero_subtitle = /** @type {(inputs: Landing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload once. Alchema's AI control layer tailors every application to the job — EU data security, transparent AI governance, and your human review before every submission.`)
};

const de_landing_hero_subtitle = /** @type {(inputs: Landing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einmal hochladen. Alchemas KI-Steuerungsschicht passt jede Bewerbung an die Stelle an — EU-Datensicherheit, transparente KI-Governance und deine Kontrolle vor jeder Einreichung.`)
};

const fr_landing_hero_subtitle = /** @type {(inputs: Landing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharge une fois. Alchema adapte chaque candidature au poste — optimisé pour les ATS, propulsé par une IA européenne, données traitées dans l'UE.`)
};

const es_landing_hero_subtitle = /** @type {(inputs: Landing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube una vez. Alchema adapta cada solicitud al puesto — optimizado para ATS, impulsado por IA europea, datos tratados en la UE.`)
};

const it_landing_hero_subtitle = /** @type {(inputs: Landing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica una volta. Alchema adatta ogni candidatura al lavoro — ottimizzata per ATS, alimentata da AI europea, dati elaborati nell'UE.`)
};

const nl_landing_hero_subtitle = /** @type {(inputs: Landing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload één keer. Alchema stemt elke sollicitatie af op de baan — ATS-geoptimaliseerd, aangedreven door Europese AI, gegevens verwerkt in de EU.`)
};

const pl_landing_hero_subtitle = /** @type {(inputs: Landing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wgraj raz. Alchema dopasowuje kazda aplikacje do oferty — zoptymalizowane pod ATS, zasilane przez europejskie AI, dane przetwarzane w UE.`)
};

const fi_landing_hero_subtitle = /** @type {(inputs: Landing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa kerran. Alchema raataeloi jokaisen hakemuksen tyopaikkaan — ATS-optimoitu, eurooppalaisella tekoaelyllae, tiedot kasitelty EU:ssa.`)
};

const da_landing_hero_subtitle = /** @type {(inputs: Landing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload én gang. Alchema tilpasser hver ansoegning til jobbet — ATS-optimeret, drevet af europaeisk AI, data behandlet i EU.`)
};

const sv_landing_hero_subtitle = /** @type {(inputs: Landing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda upp en gång. Alchema anpassar varje ansokan till jobbet -- ATS-optimerat, drivet av europeisk AI, data behandlad i EU.`)
};

/**
* | output |
* | --- |
* | "Upload once. Alchema's AI control layer tailors every application to the job — EU data security, transparent AI governance, and your human review before ever..." |
*
* @param {Landing_Hero_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_hero_subtitle = /** @type {((inputs?: Landing_Hero_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_hero_subtitle(inputs)
	if (locale === "fr") return fr_landing_hero_subtitle(inputs)
	if (locale === "es") return es_landing_hero_subtitle(inputs)
	if (locale === "it") return it_landing_hero_subtitle(inputs)
	if (locale === "nl") return nl_landing_hero_subtitle(inputs)
	if (locale === "pl") return pl_landing_hero_subtitle(inputs)
	if (locale === "fi") return fi_landing_hero_subtitle(inputs)
	if (locale === "da") return da_landing_hero_subtitle(inputs)
	if (locale === "sv") return sv_landing_hero_subtitle(inputs)
	return en_landing_hero_subtitle(inputs)
});